export class TimestampMapper {
  public static toDateOnly(selectedDate: Date): string {
    return new Date(
      Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 12),
    ).toISOString();
  }
  public static toTimeOnly(selectedTime: Date): string {
    const dateText = selectedTime.toTimeString();
    return dateText.split(' ')[0];
  }
  public static fromTimeOnlyToDate(selectedTime: string): Date {
    return new Date(new Date().toDateString() + ' ' + selectedTime);
  }
}
